<ngx-smart-modal #invoiceModal identifier="invoiceModal" customClass="medium-modal" style="background: #c2c2c220;">
  <div *ngIf="invoice != null" style="background: #c2c2c220;padding: 0 15px;">
    <button style="float:right" (click)="editStore()" class="btn btn-sm">Ver Faturas</button>
    <button style="float:right" (click)="openInvoice(invoice)" class="btn btn-sm">Abrir Fatura</button>
    <legend style="margin-bottom: 0;margin-top:10px">
      ({{ invoice.date | date:'dd/MM/yy' : 'UTC 0'}}) {{ invoice.storeName}} - MRR:
      R${{invoice.polenMRR | number:'1.2-2'}} / Mensalidade: R${{invoice.polenSubscription | number:'1.2-2'}}
      /
      Doação: R${{invoice.totalDonationApproved | number:'1.2-2'}}
      <div class="btn btn-xs btn-fill  btn-primary">{{invoiceTypeEdit}}</div>
    </legend>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="card">
          <h4 class="card-header">Configurações</h4>
          <div class="card-content">
            <div class="form-group">
              <label class="control-label">Code: <span style="font-weight: normal;">{{ invoice.code }}</span></label>
            </div>
            <div class="form-group">
              <label class="control-label">Id: <span style="font-weight: normal;">{{ invoice.id }}</span></label>
            </div>
            <div class="form-group">
              <label class="control-label">SeoUrl: <span style="font-weight: normal;">{{ invoice.storeSeoName }}</span>
              </label>
            </div>
            <div class="planos">
              <div class="form-group">
                <label class="control-label">Planos:</label>
                <div class="input-group">
                  <input *ngIf="invoice.planSeoName != 'percentual'" class="form-control" type="text"
                    placeholder="Adicionar comprovante de deposito" name="planSeoName" [(ngModel)]="invoice.planSeoName"
                    #planSeoName="ngModel" class="form-control" />
                  <span class="input-group-addon">
                    <button class="btn btn-info btn-fill btn-xs" type="button" (click)="updatePlan(invoice)">Atualizar
                      Plano</button>
                  </span>
                </div>
              </div>
            </div>
            <div class="datacriacao">
              <div class="form-group">
                <label class="control-label">Data da Criação:</label>
                <div class="input-group" style="margin-bottom: 0;">
                  <input class="form-control" type="text" placeholder="Data" name="date" [(ngModel)]="invoice.date"
                    #date="ngModel" class="form-control" />
                  <span class="input-group-addon">
                    <button class="btn btn-info btn-fill btn-xs" type="button" (click)="updateStatementDate(invoice)">
                      Atualizar Data</button>
                  </span>
                </div>
                <hr>
                <small>(De: {{ invoice.fromDate | date:'dd/MM/yyyy' : 'UTC 0'}} até {{ invoice.toDate |
              date:'dd/MM/yyyy' : 'UTC 0'}})</small>
              </div>
            </div>
            <div class="planos">
              <div class="form-group">
                <label class="control-label">Método de Pagamento:</label>
                <small *ngIf="invoice.invoiceId != null && invoice.invoiceId != ''">Só é possível mudar o pagamento sem
                  Invoice gerada</small>
                <div class="input-group" style="    display: flex;
                flex-direction: row;
                align-items: baseline;
                justify-content: space-evenly;">
                  <div class="checkbox" *ngFor="let list of fixPaymentList">
                    <input type="checkbox" value="{{list.id}}" (change)="onPaymentListChange(list,$event)"
                      [checked]="invoice.paymentList.indexOf(list.id) >= 0" [disabled]="invoice.invoiceId != null">
                    <label>{{list.value}}</label>
                  </div>
                  <span>
                    <button class="btn btn-info btn-fill btn-xs" [disabled]="invoice.invoiceId != null" type="button"
                      (click)="updatePaymentList(invoice)">Atualizar
                      M. Pagamento</button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <h4 class="card-header">Valores</h4>
          <div class="card-content">
            <div class="form-group">
              <label class="control-label">MRR:</label>
              <div>
                <input class="form-control" type="text" name="polenMRR" currencyMask [(ngModel)]="invoice.polenMRR"
                  [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" #polenMRR="ngModel" placeholder="R$0,00"
                  style="text-align: left !important;" required />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">Receita:
                <span *ngIf="invoice.planSeoName != 'percentual'">(Valor Fixo)</span>
                <span *ngIf="invoice.planSeoName == 'percentual'">(Valor Percentual)</span>
              </label>
              <div *ngIf="invoice.planSeoName != 'percentual'">
                <input class="form-control" type="text" name="polenSubscription" currencyMask
                  [(ngModel)]="invoice.polenSubscription" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                  #polenSubscription="ngModel" placeholder="R$0,00" style="text-align: left !important;" required />
              </div>
              <div *ngIf="invoice.planSeoName == 'percentual'">
                <input class="form-control" type="text" name="totalCommission" currencyMask
                  [(ngModel)]="invoice.totalCommission" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                  #totalCommission="ngModel" placeholder="R$0,00" style="text-align: left !important;" required />
              </div>
            </div>
            <div class="form-group text-right">
              <button class="btn btn-info btn-fill btn-xs" type="button"
                (click)="updatePolenSubscription(invoice)">Atualizar
                Valores</button>
            </div>
            <div class="form-group" *ngIf="invoice.prePaid > 0">
              <label class="control-label">Pré-Pago:</label>
              <br><small>Saldo carregado para a conta Polen</small>
              <div>
                <input class="form-control" type="text" name="finalPrePaid" currencyMask disabled
                  [(ngModel)]="invoice.finalPrePaid" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                  #finalPrePaid="ngModel" placeholder="R$0,00" style="text-align: left !important;" />
              </div>            
            </div>
          </div>
        </div>
        <div class="card">
          <h4 class="card-header">Itens</h4>
          <div class="card-content">
            <p style="margin-bottom: 0;">Caso queira adicionar outros itens à fatura:</p>
            <small>1. No caso de desconto, coloque o valor negativo. ex.: -10</small><br>
            <small>2. Os numeros vocês devem usar . (ponto) invés de , (vírgular). Ou seja, colocar 97.50 invés de
              97,50</small>
            <hr>
            <div class="row" *ngFor="let ngo of invoice.subItens;let i = index;trackBy: trackSubItemById">
              <div class="col-lg-6">
                <input [(ngModel)]="invoice.subItens[i].description" name="description" #description="ngModel"
                  class="form-control col-lg-4 col-sm-4" placeholder="descrição do item" />
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <span class="input-group-addon">R$</span>
                  <input class="form-control col-lg-4 col-sm-4" type="text" name="value"
                    [(ngModel)]="invoice.subItens[i].value" #value="ngModel" placeholder="0,00" required />
                </div>
              </div>
              <br>
            </div>
            <hr>
            <button class="btn btn-info btn-sm" type="button" (click)="AddRemoveSubItem('plus')"> + item</button>
            <button class="btn btn-info btn-sm" type="button" (click)="AddRemoveSubItem('less')"> - item</button>
            <div class="form-group text-right">
              <button class="btn btn-info btn-sm" type="button" (click)="updateSubItens()">Atualizar SubItens</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-content">
            <section class="products">
              <planItens-viewer [profile]="profile" [seoUrl]="PlanItemViewerKey"></planItens-viewer>
            </section>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="card">
          <h4 class="card-header">Invoice</h4>
          <div class="card-content">
            <form name="form" (ngSubmit)="f.form.valid" #f="ngForm" novalidate>
              <div class="form-group">
                <label class="control-label">Id da Invoice:</label>
                <input class="form-control" type="text" name="invoiceId" [(ngModel)]="invoice.invoiceId"
                  #invoiceId="ngModel" class="form-control" />
              </div>
              <div class="form-group">
                <label class="control-label">Link da Invoice:</label>
                <div class="input-group">
                  <input class="form-control" type="text" placeholder="url da fatura" name="invoiceUrl"
                    [(ngModel)]="invoice.invoiceUrl" #invoiceUrl="ngModel" class="form-control" />
                  <span class="input-group-addon"><a *ngIf="invoice.invoiceUrl != null" [href]="invoice.invoiceUrl"
                      target="_blank" class="btn btn-xs btn-success btn-wd">Ver fatura</a></span>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label">Data de Vencimento:</label>
                <input class="form-control" type="text" placeholder="dd/mm/yyyy" name="invoiceDate"
                  [(ngModel)]="invoice.invoiceDate" #invoiceDate="ngModel" class="form-control" />
              </div>
              <div class="form-group">
                <label class="control-label">Data do Pagamento Disponível:</label>
                <input class="form-control" type="text" placeholder="dd/mm/yyyy" name="paymentAvailableDate"
                  [(ngModel)]="invoice.paymentAvailableDate" #paymentAvailableDate="ngModel" class="form-control" />
                  <small>só preencha essa informação caso esteja alterando manualmente o status desta fatura para Pago</small>
              </div>
              <div class="form-group">
                <label class="control-label">Fatura enviada?</label>
                <label class="switch">
                  <input type="checkbox" name="invoiceSent" [checked]="invoice.invoiceSent"
                    (change)="invoice.invoiceSent= !invoice.invoiceSent">
                  <span class="slider round"></span>
                </label>
              </div>
              <div class="form-group">
                <label class="control-label">Status da Fatura:</label>
                <select class="form-control" name="statusStatement" [(ngModel)]="invoice.statusStatement">
                  <option [value]="1">Aguardando Pagamento</option>
                  <option [value]="2">Loja Pagou</option>
                  <option [value]="3">Doado Parcialmente</option>
                  <option [value]="4">Doação Feita</option>
                  <option [value]="5">Aguardando Dados das Ongs</option>
                  <option [value]="10">Completado</option>
                  <option [value]="11">Loja NÃO pagou</option>
                  <option [value]="12">Cancelar</option>
                  <option [value]="20">Problema no pagamento</option>
                  <option [value]="21">Estornado</option>
                  <option [value]="22">ChargeBack</option>
                </select>
              </div>
              <div class="form-group">
                <label class="control-label">Log de Erros:</label> <br>
                <div *ngIf="invoice.invoiceError == null">Erro: -</div>
                <div *ngIf="invoice.invoiceError != null">Erro: {{ invoice.invoiceError}}</div>
              </div>
              <div class="form-group text-right">               
                <a (click)="chooseCreateInvoiceFromStatement(invoice)" class="btn btn-xs  btn-success">Gerar 2º Via</a>
                <button *ngIf="invoiceTypeEdit == 'juno'" class="btn btn-danger" style="float: left;" type="button"
                  (click)="cancelInvoice(invoice)">Cancelar</button>
                <button class="btn btn-info btn-fill" type="button" (click)="updateStatementInvoice(invoice)">Atualizar
                  Fatura</button>
              </div>
            </form>
          </div>
        </div>
        <div class="card">
          <h4 class="card-header">Logs da Iugu</h4>
          <div class="card-content">
            <p class="" *ngFor="let log of invoice.logPayment; let i = index">
              {{ log }}
            </p>
          </div>
        </div>
        <div class="card">
          <h4 class="card-header">Nota Fiscal</h4>
          <div class="card-content">
            <form name="form" (ngSubmit)="f.form.valid" #f="ngForm" novalidate>
              <div class="form-group">
                <label class="control-label">Id da Nota Fiscal:</label>
                <input class="form-control" type="text" name="taxStatementId" [(ngModel)]="invoice.taxStatementId"
                  #taxStatementId="ngModel" class="form-control" />
              </div>
              <div class="form-group">
                <label class="control-label"> Link da Nota Fiscal:</label>
                <input class="form-control" type="text" placeholder="url da nota fiscal" name="taxStatementUrl"
                  [(ngModel)]="invoice.taxStatementUrl" #taxStatementUrl="ngModel" class="form-control" />
              </div>
              <div class="form-group">
                <a *ngIf="invoice.taxStatementUrl != null" [href]="invoice.taxStatementUrl" target="_blank"
                  class="btn btn-xs btn-success btn-wd">Ver Nota Fiscal</a>
              </div>
              <div class="form-group text-right">
                <button class="btn btn-info btn-fill" type="button" (click)="updateNotaFiscal(invoice)">Atualizar Nota
                  Fiscal</button>
              </div>
            </form>
            <ng-container *ngIf="invoice.listFiscalInvoice != null && invoice.listFiscalInvoice.length > 0">
              <p>Caso a NF tenha sido dividida, exibimos aqui todas as NFs que serão lançadas para esta fatura em seus respectivos meses.</p>
              <table class="table table-striped">
                <tr>
                  <td>Data</td>
                  <td>Numero</td>
                  <td>Valor da NF</td>
                  <td>Status</td>
                </tr>
                  <tr *ngFor="let fiscal of invoice.listFiscalInvoice">
                    <td>{{ fiscal.date | date:'dd/MM/yy' : 'UTC 0'}}</td>
                    <td>{{ fiscal.nfNumber}}</td>
                    <td>R$ {{ fiscal.value | number:'1.2-2'}}</td>
                    <td *ngIf="fiscal.status == 1">
                      <a *ngIf="(fiscal.nfUrl == null || fiscal.nfUrl == '') && fiscal.nfId != null && fiscal.nfId != 'no-nf-required'"
                      style="float:right" target="_blank"
                      href="https://api.nfe.io/v1/companies/5c3dde05d41d7c1da479c8ed/serviceinvoices/{{ fiscal.nfId }}/pdf?apiKey=ICXlatZNOcWxDDfRxYkErBCiCqIVuk2KpNV47oRuqLnXDpSrDye01UjHYK2Uc2ZbqN7"
                      class="btn btn-xs btn-success">NF Emitida</a>
                    </td>
                    <td *ngIf="fiscal.status != 1">
                      <a *ngIf="fiscal.status == 0" style="float:right" class="btn btn-xs btn-waiting">Aguardando</a>
                      <a *ngIf="fiscal.status == 2" style="float:right" class="btn btn-xs btn-danger">Falhou</a>
                      <a *ngIf="fiscal.status == 3" style="float:right" class="btn btn-xs btn-danger">Cancelado</a>
                    </td>
                    </tr>
              </table>
            </ng-container>
            
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <h4 class="card-header">Doações nessa fatura</h4>
          <div class="card-content">
            <div *ngIf="invoice.ngos == null">Sem Ongs apoiadas nesta fatura</div>
            <div *ngIf="invoice.ngos != null">
              <table class="table table-striped">
                <tbody>
                  <tr *ngFor="let ngo of invoice.ngos">
                    <td>[{{ngo.code}}] {{ ngo.ngoName}}</td>
                    <td *ngIf="invoice.planSeoName == 'percentual'">{{
                    invoice.commissionPercentage | number:'1.2-2'}} -
                      R$ {{ ((1 - invoice.commissionPercentage) * ngo.donation) |
                    number:'1.2-2'}}
                      (R${{ ngo.donation | number:'1.2-2'}})</td>
                    <td *ngIf="invoice.planSeoName != 'percentual'">R$ {{ ngo.donation |
                    number:'1.2-2'}}</td>
                    <td>
                      <div style="border: 1px solid gray">
                        <label>Alterar valor da doação:</label>
                        <input class="form-control" type="text" placeholder="Novo valor de doação"
                          [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask placeholder="R$0,00"
                          name="newDonationValue" [(ngModel)]="ngo.newDonationValue" #newDonationValue="ngModel"
                          class="form-control" />
                        <input class="form-control" type="text" placeholder="Explique pq está mudando"
                          name="newDescription" [(ngModel)]="ngo.newDescription" #newDescription="ngModel"
                          class="form-control" />
                        <button style="float: right;" class="btn btn-info btn-xs btn-fill" type="button"
                          (click)="updateDonationValue(invoice,ngo)">Atualizar doação</button>
                      </div>
                    </td>
                    <td *ngIf="invoice.planSeoName != 'percentual'">
                      <div *ngIf=" ngo.statusStatement == 7" class="pull-left"><span class="label label-warning">
                          Aguardando
                          Saque </span></div>
                      <div *ngIf=" ngo.statusStatement == 3" class="pull-left"><span class="label label-success">
                          Depositado
                        </span></div>
                      <div class="label label-default">Status ({{ ngo.statusStatement}})</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ngx-smart-modal>